import * as React from "react";

import AddressSearchForContext from '../address/AddressSearchForContext';
import PropTypes from 'prop-types';

import styles from './AddressSearchForContext.module.css';

/**
 * Address prompt with some styling for use in place of listing content
 * ( When we don't have any address info )
 */
const AddressInputSection = ({
  onAddressSelect
}) => {
  return (
    <div className={styles.sectionWrap}>
      <div className={styles.addressPrompt}>
        Let's find the best dispensaries <i>near&nbsp;you!</i>
      </div>
      <div className={styles.addressInput}>
        <AddressSearchForContext 
          buttonText="Search"
          pinColor="var(--zrDarkBlue)"
          trackingLabel={'address_section_submit'} 
          onComplete={onAddressSelect} />
      </div>
    </div>
  );
}

AddressInputSection.propTypes = {
  onAddressSelect: PropTypes.func.isRequired
};

export default AddressInputSection;